import { render } from 'react-dom'
import React from 'react'
import Router from './router'
import './app.scss'
import HttpsApp from 'react-https-redirect'

// <AppContainer>

render(
  <HttpsApp>
    <Router />
  </HttpsApp>
  ,
  document.getElementById('app')
)

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then(registration => {
      console.log('SW registered: ', registration)
    }).catch(registrationError => {
      console.log('SW registration failed: ', registrationError)
    })
  })
}
